import React from "react";
import {useTranslation} from "react-i18next";
import {CompetenceResult} from "../../../schema";
import classes from "./CompetenceResultsModal.module.css";

type Props = {
  competenceResults: CompetenceResult[];
};

function CompetenceResultsModalHeader() {
  const {t} = useTranslation();
  return <>{t("components.OfflineTestSessionsTable.competenceResults")}</>;
}

function CompetenceResultsModalContent({competenceResults}: Props) {
  const {t} = useTranslation();
  return (
    <div className={classes.content}>
      <div className={classes.resultsList}>
        {competenceResults.map((result, index) => (
          <div key={index} className={classes.resultItem}>
            <div className={classes.resultHeader}>
              <span className={classes.competenceName}>{result.competence || ""}</span>
              <span className={classes.competenceScore}>
                {Math.round((result.score || 0) * 100)}%
              </span>
            </div>
            {result.indicators && result.indicators.length > 0 && (
              <div className={classes.indicatorsList}>
                {result.indicators.map((indicator, idx) => (
                  <div key={idx} className={classes.indicatorItem}>
                    <span className={classes.indicatorName}>
                      {indicator.indicator}: {indicator.isPresent
                      ? t("components.ResultsDisplay.indicator.present")
                      : t("components.ResultsDisplay.indicator.notPresent")}
                    </span>
                    {indicator.example && (
                      <>
                        {" "}
                        <span className={classes.indicatorExample}>
                          ({t("components.ResultsDisplay.indicator.example")}: "{indicator.example}")
                        </span>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
            {(!result.indicators || result.indicators.length === 0) && (
              <div className={classes.noIndicatorsWarning}>
                {t("components.CompetenceResultsModal.noIndicatorsWarning")}
              </div>
            )}
            {result.feedback && (
              <div className={classes.feedback}>
                {result.feedback}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const CompetenceResultsModal = {
  Header: CompetenceResultsModalHeader,
  Content: CompetenceResultsModalContent,
};

export default CompetenceResultsModal;

